import { modelHelperModule } from './model-helper';
import { assessmentModelModule } from './assessment';

export const assessmentTemplateModelModule = angular
  .module('Q.models.assessment-template', [
    modelHelperModule,
    assessmentModelModule,
  ])

  .factory(
    'AssessmentTemplate',
    function defineResource(ModelHelper, Assessment, $injector) {
      return ModelHelper.defineResource({
        name: 'AssessmentTemplate',
        endpoint: 'assessment_templates',
        computed: Assessment.computed,
        methods: angular.extend({}, Assessment.methods, {
          // returns true if some sort of upgrade is required. Pass 'full' if you wish to check
          // if a full upgrade is required, 'partial' if you wish to check if a partial,
          // otherwise either type will be considered
          upgradeRequired(checkType, allowStaff) {
            if (allowStaff) {
              // look up permissions service here to make sure it happens after the app has been bootstrapped
              const permissionsService =
                $injector.has('permissionsService') &&
                $injector.get('permissionsService');
              if (permissionsService && permissionsService.role('staff')) {
                return false;
              }
            }

            if (this._upgradeRequired === undefined) {
              const needs = this.upgradeRequiredItems().length;
              if (needs === this.challengeItems.length) {
                // 2 == full upgrade required
                this._upgradeRequired = 'full';
              } else {
                this._upgradeRequired = needs > 0 ? 'partial' : false;
              }
            }

            return checkType
              ? this._upgradeRequired === checkType
              : !!this._upgradeRequired;
          },
          upgradeRequiredItems() {
            return this.challengeItems.filter(
              (item) =>
                item.challenge.requiresUpgrade ||
                item.challenge.teamRequiresUpgrade,
            );
          },
          quizOnly() {
            return this.challengeItems.every((ci) => ci.challenge.isQuiz());
          },
          challengesWithLanguages() {
            return this.challengeItems.filter(
              (ci) => ci.challenge.languages && ci.challenge.languages.length,
            );
          },
          leastAvailableLanguages() {
            // find the challenge item with the least number of languages, or return an empty array
            return (
              this.challengesWithLanguages()
                .map((ci) => ci.challenge.languages)
                .reduce(
                  (prev, next) =>
                    !prev || next.length < prev.length ? next : prev,
                  null,
                ) || []
            );
          },
          defaultEnabledLanguages() {
            let challengeItems = this.challengesWithLanguages();
            // return the languages enabled in all challlenges
            return this.leastAvailableLanguages()
              .filter((language) => {
                let name = language.name;
                return challengeItems.every((ci) => {
                  let languages = ci.challenge.languages.map((l) => l.name);
                  let disabledLanguages = ci.disabledLanguages;
                  return (
                    languages.indexOf(name) > -1 &&
                    disabledLanguages.indexOf(name) === -1
                  );
                });
              })
              .map((l) => l.name);
          },
          availableLanguages() {
            let challengeItems = this.challengesWithLanguages();
            // return the languages that are in all the challenges
            return this.leastAvailableLanguages()
              .filter((language) => {
                let name = language.name;
                return challengeItems.every((ci) => {
                  let languages = ci.challenge.languages.map((l) => l.name);
                  return languages.indexOf(name) > -1;
                });
              })
              .map((l) => l.name);
          },
        }),

        relations: {
          hasMany: {
            ChallengeItem: {
              localField: 'challengeItems',
              link: false,
            },
          },
        },

        meta: {
          actionEndpoints: {
            import: {
              method: 'PUT',
              responseHandler: (response) => {
                let data = ModelHelper.deserialize(Assessment, response);
                return Assessment.inject(data);
              },
            },
          },
        },
      });
    },
  );
